<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.04471 6.85704L5.34409 5.30913M5.89674 3.61307C5.89674 4.97721 4.79062 6.08307 3.42615 6.08307C2.06169 6.08307 0.955566 4.97721 0.955566 3.61307C0.955566 2.24892 2.06169 1.14307 3.42615 1.14307C4.79062 1.14307 5.89674 2.24892 5.89674 3.61307Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
